import CompanyDashboardContainer from './company-dashboard.container';

export default CompanyDashboardContainer;
